import React, { useState, useEffect, useRef } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Button } from "primereact/button";
import Snackbar from "@mui/material/Snackbar";
import IconButton from "@mui/material/IconButton";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import CloseIcon from "@mui/icons-material/Close";
import axios from "axios";
import formattedDate from "../formatDate";
import { Dialog } from "primereact/dialog";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import "primeicons/primeicons.css";
import { InputText } from "primereact/inputtext";
import { IconField } from "primereact/iconfield";
import { InputIcon } from "primereact/inputicon";
import { Tag } from "primereact/tag";
import mapEtatFiche from "../mapEtatFiche";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { fr } from "date-fns/locale";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { TextField, TextareaAutosize } from "@mui/material";
import formatToISODate from "../formatDateISO";
import mapDim from "../mapDimensionBox";
import FicheLogTerminalStock from "./journalFiche";

import EditIcon from "@mui/icons-material/Edit";
import CheckIcon from "@mui/icons-material/Check";

const apiUrl = process.env.REACT_APP_API_URL;

export default function Abandonnee({ searchTerm = "" }) {
  const [editMode, setEditMode] = useState(false);

  const [loading, setLoading] = useState(true);

  const [ficheListeGiveUp, setFicheListeGiveUp] = useState([]);

  const [copiedText, setCopiedText] = useState("");
  const [openSnackbar, setOpenSnackbar] = useState(false);

  const [openSnackbarMail, setOpenSnackbarMail] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");

  const [visible, setVisible] = useState(false);
  const [appel, setAppel] = useState("");
  const [note, setNote] = useState("");
  const [dateEnvoiDevis, setDateEnvoiDevis] = useState("");
  const [dateMAJ, setDateMAJ] = useState("");
  const [infoMAJ, setInfoMAJ] = useState("");

  const [tempName, setTempName] = useState("");
  const [tempNum, setTempNum] = useState("");
  const [tempBesoin, setTempBesoin] = useState("");
  const [tempMail, setTempMail] = useState("");
  const [tempDispo, setTempDispo] = useState("");
  const [tempIdFiche, setTempIdFiche] = useState("");
  const [tempDuree, setTempDuree] = useState("");
  const [tempEtat, setTempEtat] = useState("");
  const [tempNbRepondeur, setTempNbRepondeur] = useState("");
  const [tempDateRappel, setTempDateRappel] = useState("");

  const [rechercheGv, setRechercheGv] = useState("");

  const [ficheListeFiltreGv, setFicheListeFiltreGv] =
    useState(ficheListeGiveUp);

  const [dateRappel, setDateRappel] = useState("");

  useEffect(() => {
    const rechercheMin = searchTerm.toLowerCase();
    const filteredList2 = ficheListeGiveUp.filter((fiche) => {
      const nom = fiche.nom?.toLowerCase() || "";
      const num = fiche.num?.toLowerCase() || "";
      const ville = fiche.ville?.toLowerCase() || "";
      const mail = fiche.mail?.toLowerCase() || "";

      return (
        nom.includes(rechercheMin) ||
        num.includes(rechercheMin) ||
        ville.includes(rechercheMin) ||
        mail.includes(rechercheMin)
      );
    });
    setFicheListeFiltreGv(filteredList2);
  }, [searchTerm, ficheListeGiveUp]);

  const setInfoClick = (idFiche, name, numero, Besoin, mail) => {
    setNote("");
    setAppel("");
    setDateMAJ("");
    setInfoMAJ("");
    setTempDispo("");
    // setDateEnvoiDevis("");

    setTempName(name);
    setTempNum(numero);
    setTempBesoin(Besoin);
    setTempMail(mail);
    setTempIdFiche(idFiche);

    axios
      .get(`${apiUrl}IHM/api/fiche.php?idFiche=${idFiche}`)
      .then((response) => {
        // setNote(response.data[0].note);
        setAppel(response.data[0].etat);

        setDateMAJ(response.data[0].dateNote);
        setInfoMAJ(response.data[0].adminNote);
        setTempDuree(response.data[0].duree);
        setTempEtat(response.data[0].etat);
        setTempNbRepondeur(response.data[0].nbRepondeur);
        setTempDispo(response.data[0].disposition);

        // setDateEnvoiDevis(new Date(response.data[0].dateEnvoiDevis));

        setTempDateRappel(response.data[0].dateRappel);
        setVisible(true);
      })
      .catch((error) => {
        console.error(
          "Une erreur s'est produite lors de la récupération de la fiche :",
          error
        );
      });
  };

  const copyToClipboard = (text) => {
    if (text !== "") {
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard
          .writeText(text)
          .then(() => {
            setCopiedText(text);
            setOpenSnackbar(true);
          })
          .catch((error) => {
            console.error(
              "Erreur lors de la copie dans le presse-papiers : ",
              error
            );
          });
      } else {
        // Utiliser l'API de sélection de texte comme solution de secours
        const textArea = document.createElement("textarea");
        textArea.value = text;
        document.body.appendChild(textArea);
        textArea.select();
        document.execCommand("copy");
        document.body.removeChild(textArea);

        setCopiedText(text);
        setOpenSnackbar(true);
      }
    }
  };
  const handleCloseSnackbar = () => {
    setOpenSnackbar(false);
  };
  const handleCloseSnackbarMail = () => {
    setOpenSnackbarMail(false);
  };
  const handleSavePhoneCall = async () => {
    let data = {
      idFiche: tempIdFiche,
      etat: appel,
      note: note,
      adminMod: localStorage.getItem("us"),
    };

    if (dateRappel && appel === "2") {
      data.dateRappel = formatToISODate(dateRappel);
    }
    if (dateEnvoiDevis && appel === "1") {
      data.dateEnvoiDevis = formatToISODate(dateEnvoiDevis);
    }

    // if (appel === "1") {
    //   data.dateEnvoiDevis = formatToISODate(dateEnvoiDevis);
    //   data.dateRappel = formatToISODate(dateRappel);
    // }
    try {
      let response;
      if (appel === "4") {
        response = await axios.post(`${apiUrl}IHM/api/zotDevis.php`, {
          idFiche: tempIdFiche,
          note: note,
          adminMod: localStorage.getItem("us"),
        });
        if (response.data.success) {
          window.location.reload();
        } else {
          alert("Erreur : " + response.data.message);
        }
      } else if (appel === "6") {
        response = await axios.post(`${apiUrl}IHM/api/zotDevis.php`, {
          idFicheW: tempIdFiche,
          note: note,
          adminMod: localStorage.getItem("us"),
        });
        if (response.data.success) {
          window.location.reload();
        } else {
          alert("Erreur : " + response.data.message);
        }
      } else {
        response = await axios.put(`${apiUrl}IHM/api/fiche.php`, data);
        if (response.data) {
          setVisible(false);
          window.location.reload();
        } else {
          setVisible(false);
          window.location.reload();
        }
      }
    } catch (error) {
      console.error(
        "Erreur lors de la sauvegarde de l'appel téléphonique",
        error
      );
    }
  };

  useEffect(() => {
    axios
      .get(`${apiUrl}/IHM/api/fiche.php?idFicheListeGiveUp`)
      .then((response) => {
        setFicheListeGiveUp(response.data);
      })
      .catch((error) => {
        console.error(
          "Erreur lors du chargement des fiches abandonnées :",
          error
        );
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);

  const enteteTabeauGv = () => {
    return (
      <div className="flex justify-content-end">
       
      </div>
    );
  };

  const handleValidate = async () => {
    try {
      await axios.post(`${apiUrl}IHM/api/update_fiche.php`, {
        idFiche: tempIdFiche,
        nom: tempName,
        telephone: tempNum,
        email: tempMail,
        duree: tempDuree,
        volume: tempBesoin,
        disposition: tempDispo,
      });
      setEditMode(false);
    } catch (error) {
      console.error("Erreur de mise à jour :", error);
      alert("Erreur lors de la sauvegarde");
    } finally {
    }
  };

  const header = (
    <div className="flex justify-between items-center w-full">
      <span className="font-semibold text-lg mr-2">Fiche de stockage</span>
      <div className="flex items-center gap-2">
        <span style={{ cursor: "pointer" }}>
          {editMode ? (
            <>
              <span
                onClick={() => handleValidate()}
                style={{
                  border: "1px solid #22c55e",
                  borderRadius: "50%",
                  color: "#fff",
                  width: "28px",
                  height: "28px",
                  display: "inline-flex",
                  alignItems: "center",
                  justifyContent: "center",
                  cursor: "pointer",
                  marginRight: "8px",
                  transition: "all 0.2s ease",

                  backgroundColor: "#22c55e",
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.backgroundColor = "#22c55e";
                  e.currentTarget.style.color = "#fff";
                }}
              >
                <CheckIcon sx={{ fontSize: 16 }} />
              </span>

              <span
                onClick={() => setEditMode(false)}
                style={{
                  border: "1px solid #ef4444",
                  borderRadius: "50%",
                  color: "#ffffffff",
                  width: "28px",
                  height: "28px",
                  display: "inline-flex",
                  alignItems: "center",
                  justifyContent: "center",
                  cursor: "pointer",
                  transition: "all 0.2s ease",
                  backgroundColor: "#ef4444",
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.backgroundColor = "#ef4444";
                  e.currentTarget.style.color = "#fff";
                }}
              >
                <CloseIcon sx={{ fontSize: 16 }} />
              </span>
            </>
          ) : (
            <span
              style={{
                border: "1px solid #4b5563",
                borderRadius: "50%",
                color: "#ffffffff",
                width: "28px",
                height: "28px",
                display: "inline-flex",
                alignItems: "center",
                justifyContent: "center",
                cursor: "pointer",
                marginRight: "8px",
                transition: "all 0.2s ease",
                backgroundColor: "#4b5563",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.backgroundColor = "#4b5563";
                e.currentTarget.style.color = "#fff";
              }}
              onClick={() => setEditMode(true)}
            >
              {" "}
              <EditIcon sx={{ fontSize: 16 }} />{" "}
            </span>
          )}
        </span>
      </div>
    </div>
  );

  return (
    <>
      <Snackbar
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        open={openSnackbarMail}
        autoHideDuration={1000}
        onClose={handleCloseSnackbarMail}
        message={snackbarMessage}
        action={
          <React.Fragment>
            <IconButton
              size="small"
              aria-label="close"
              color="inherit"
              onClick={handleCloseSnackbarMail}
            >
              <CloseIcon fontSize="small" />
            </IconButton>
          </React.Fragment>
        }
      />

      <Snackbar
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        open={openSnackbar}
        autoHideDuration={1000}
        onClose={handleCloseSnackbar}
        message={`Copie réussie de " ${
          copiedText === "location.mail" ? "e-mail" : copiedText
        } "`}
        action={
          <React.Fragment>
            <IconButton
              size="small"
              aria-label="close"
              color="inherit"
              onClick={handleCloseSnackbar}
            >
              <CloseIcon fontSize="small" />
            </IconButton>
          </React.Fragment>
        }
      />

      <Dialog
        blockScroll
        visible={visible}
        onHide={() => {
          setVisible(false);
          setEditMode(false);
        }}
        header={header}
        className="custom-dialog"
        style={{ width: "40vw" }}
        modal
        breakpoints={{ "960px": "100vw", "640px": "100vw" }}
      >
        <div className="p-3">
          <div className="grid">
            {/* Etat actuel */}
            <div className="col-12 md:col-6">
              <div className="p-2 px-0 surface-100 border-round-sm flex justify-between align-items-left">
                <span className="font-bold">État actuel :</span>
                <span
                  className="p-1 px-2 text-sm"
                  style={{ background: "#e5e7eb", borderRadius: "5px" }}
                >
                  {mapEtatFiche(tempEtat)}{" "}
                  <small>
                    <small>({tempNbRepondeur})</small>
                  </small>
                </span>
              </div>
            </div>

            {/* Etat souhaité */}
            <div className="col-12 md:col-6">
              <div className="p-2 px-0 surface-100 border-round-sm flex justify-between align-items-left">
                <span className="font-bold">État souhaité :</span>
                <Select
                  labelId="etat-label"
                  id="etat-select"
                  value={appel}
                  onChange={(e) => setAppel(e.target.value)}
                  displayEmpty
                  style={{
                    minWidth: "130px",
                    maxWidth: "130px",
                    maxHeight: "20px",
                  }}
                >
                  <MenuItem value="" disabled>
                    Séléctionner un état
                  </MenuItem>
                  <MenuItem value="0">En cours</MenuItem>
                  <MenuItem value="1">Suivis</MenuItem>
                  <MenuItem value="7">Validé</MenuItem>
                  <MenuItem value="8">Stockage</MenuItem>
                  <MenuItem value="3">Abandonnées</MenuItem>
                  <MenuItem value="4">Vers Zotdevis (Nord)</MenuItem>
                  <MenuItem value="6">Vers Zotdevis (Ouest)</MenuItem>
                </Select>
              </div>
            </div>
          </div>
          {/* Ligne 1 */}
          <div className="grid">
            <div className="col-12 md:col-6">
              <div
                className="p-2 px-0 border-round-sm flex justify-between align-items-left"
                style={{ background: "#f9fafb", borderRadius: "5px" }}
              >
                <span className="font-bold">Nom :</span>

                {editMode ? (
                  <InputText
                    value={tempName}
                    onChange={(e) => setTempName(e.target.value)}
                    style={{ height: "10px" }}
                  />
                ) : (
                  <span
                    onClick={() => copyToClipboard(tempName)}
                    className="cursor-pointer"
                  >
                    {tempName} <ContentCopyIcon sx={{ fontSize: 12 }} />
                  </span>
                )}
              </div>
            </div>

            <div className="col-12 md:col-6">
              <div
                className="p-2 px-0 border-round-sm flex justify-between align-items-left"
                style={{ background: "#f9fafb", borderRadius: "5px" }}
              >
                <span className="font-bold">Volume du box :</span>
                {editMode ? (
                  <InputText
                    value={tempBesoin}
                    onChange={(e) => setTempBesoin(e.target.value)}
                    style={{ height: "10px" }}
                  />
                ) : (
                  <span
                    onClick={() => copyToClipboard(tempBesoin)}
                    className="cursor-pointer"
                  >
                    {tempBesoin} <ContentCopyIcon sx={{ fontSize: 12 }} />
                  </span>
                )}
              </div>
            </div>
          </div>

          {/* Ligne 2 */}
          <div className="grid">
            <div className="col-12 md:col-6">
              <div
                className="p-2 px-0 border-round-sm flex justify-between align-items-left"
                style={{ background: "#f9fafb", borderRadius: "5px" }}
              >
                <span className="font-bold">Téléphone :</span>

                {editMode ? (
                  <InputText
                    value={tempNum}
                    onChange={(e) => setTempNum(e.target.value)}
                    style={{ height: "10px" }}
                  />
                ) : (
                  <span
                    onClick={() => copyToClipboard(tempNum)}
                    className="cursor-pointer"
                  >
                    {tempNum} <ContentCopyIcon sx={{ fontSize: 12 }} />
                  </span>
                )}
              </div>
            </div>

            <div className="col-12 md:col-6">
              <div
                className="p-2 px-0 border-round-sm flex justify-between align-items-left"
                style={{ background: "#f9fafb", borderRadius: "5px" }}
              >
                <span className="font-bold">Durée :</span>
                {editMode ? (
                  <InputText
                    value={tempDuree}
                    onChange={(e) => setTempDuree(e.target.value)}
                    style={{ height: "10px" }}
                  />
                ) : (
                  <span
                    onClick={() => copyToClipboard(tempDuree)}
                    className="cursor-pointer"
                  >
                    {tempDuree} <ContentCopyIcon sx={{ fontSize: 12 }} />
                  </span>
                )}
              </div>
            </div>
          </div>

          {/* Ligne 3 */}
          <div className="grid">
            <div className="col-12">
              <div
                className="p-2 px-0 border-round-sm flex justify-between align-items-left"
                style={{ background: "#f9fafb", borderRadius: "5px" }}
              >
                <span className="font-bold">Email :</span>
                {editMode ? (
                  <InputText
                    value={tempMail}
                    onChange={(e) => setTempMail(e.target.value)}
                    style={{ height: "10px" }}
                  />
                ) : (
                  <span
                    onClick={() => copyToClipboard(tempMail)}
                    className="cursor-pointer"
                  >
                    {tempMail} <ContentCopyIcon sx={{ fontSize: 12 }} />
                  </span>
                )}
              </div>
            </div>
          </div>

          <div className="grid">
            <div className="col-12">
              <div
                className="p-2 px-0 border-round-sm flex justify-between align-items-left"
                style={{ background: "#f9fafb", borderRadius: "5px" }}
              >
                <span className="font-bold">Disposition :</span>
                {editMode ? (
                  <InputText
                    value={tempDispo}
                    onChange={(e) => setTempDispo(e.target.value)}
                    style={{ height: "10px" }}
                  />
                ) : (
                  <span
                    onClick={() => copyToClipboard(tempDispo)}
                    className="cursor-pointer"
                  >
                    {tempDispo} <ContentCopyIcon sx={{ fontSize: 12 }} />
                  </span>
                )}
              </div>
            </div>
          </div>

          {appel === "2" && (
            <div className="grid">
              <div className="col-12 md:col-12">
                <div className="p-2 px-0 border-round-sm surface-100 flex flex-column gap-2 px-0">
                  <span className="font-bold">Date de rappel </span>
                  <LocalizationProvider
                    dateAdapter={AdapterDateFns}
                    adapterLocale={fr}
                  >
                    <DatePicker
                      value={dateRappel}
                      onChange={(newValue) => setDateRappel(newValue)}
                      renderInput={(props) => (
                        <TextField {...props} required="false" fullWidth />
                      )}
                      inputFormat="dd/MM/yyyy"
                      minDate={new Date()}
                    />
                  </LocalizationProvider>
                </div>
              </div>
            </div>
          )}

          {appel === "1" && (
            <>
              <div className="grid">
                <div className="col-12 md:col-12">
                  <div className="p-2 px-0 border-round-sm surface-100 flex flex-column gap-2 px-0">
                    <span className="font-bold">Date d'envoi du devis</span>
                    <LocalizationProvider
                      dateAdapter={AdapterDateFns}
                      adapterLocale={fr}
                    >
                      <DatePicker
                        value={dateEnvoiDevis}
                        onChange={(newValue) => setDateEnvoiDevis(newValue)}
                        renderInput={(props) => (
                          <TextField {...props} required="false" fullWidth />
                        )}
                        inputFormat="dd/MM/yyyy"
                        minDate={new Date()}
                      />
                    </LocalizationProvider>
                  </div>
                </div>
              </div>
            </>
          )}

          <div className="grid">
            <div className="col-12 md:col-12">
              <div className="py-0 px-0 border-round-sm surface-100 flex flex-column">
                <span className="font-bold">Ajouter une note :</span>
              </div>
            </div>
          </div>
          <div className="grid">
            <div className="col-12 md:col-12">
              <TextareaAutosize
                variant="standard"
                minRows={5}
                maxRows={10}
                value={note}
                onChange={(e) => setNote(e.target.value)}
                style={{ width: "100%", borderRadius: "5px" }}
                className="mt-2"
              />
            </div>
          </div>

          <div className="grid">
            <div className="col-12 md:col-12 align-items-right">
              <div className="border-round-sm surface-100 flex flex-column"></div>
              <Button
                label="Enregistrer l'état et la note"
                onMouseEnter={(e) => {
                  e.currentTarget.style.backgroundColor = "#094ed8";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.backgroundColor = "#2563eb";
                }}
                className="w-full text-white"
                style={{
                  background: "#094ed8",
                  border: "1px solid #094ed8",
                  padding: "0.75rem",
                  borderRadius: "5px",
                }}
                onClick={() => {
                  if (appel) {
                    handleSavePhoneCall();
                  }
                }}
              />
            </div>
          </div>

          <FicheLogTerminalStock idFicheDem={tempIdFiche} />
        </div>
      </Dialog>

      <DataTable
        value={ficheListeFiltreGv}
        paginator
        rows={25}
        size="small"
        header={enteteTabeauGv}
        rowsPerPageOptions={[5, 10, 25, 50]}
        tableStyle={{ minWidth: "50rem" }}
        scrollable
        scrollDirection="horizontal"
        paginatorTemplate={
          "FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink RowsPerPageDropdown"
        }
        paginatorRight={
          <span style={{ margin: "10px", fontWeight: "bold" }}>
            Résultats : {ficheListeFiltreGv.length}
          </span>
        }
        loading={loading}
        loadingIcon="pi pi-spin pi-spinner"
        emptyMessage={
          loading
            ? "Chargement des fiches abandonnées..."
            : "Aucune fiche pour le moment"
        }
      >
        <Column
          field="dateFiche"
          header="Date"
          bodyStyle={{ fontSize: "14px" }}
          body={(rowData) => {
            const date = new Date(rowData.dateFiche);
            const day = String(date.getDate()).padStart(2, "0");
            const month = String(date.getMonth() + 1).padStart(2, "0");
            const year = date.getFullYear();
            return (
              <span>
                {day}/{month}/{year}{" "}
                <small>
                  <small>({rowData.urgence})</small>
                </small>
              </span>
            );
            // return `${day}/${month}/${year} (${rowData.urgence})`;
          }}
        />

        <Column
          style={{ cursor: "pointer" }}
          field="nom"
          header="Client"
          bodyStyle={{ fontSize: "14px" }}
          body={(rowData) => (
            <div>
              <span
                onClick={() => {
                  copyToClipboard(rowData.nom);
                }}
              >
                {rowData.nom}
              </span>
            </div>
          )}
        />

        <Column
          style={{ cursor: "pointer" }}
          field="mail"
          header="Email"
          bodyStyle={{ fontSize: "14px" }}
          body={(rowData) => (
            <div>
              <span
                onClick={() => {
                  copyToClipboard(rowData.mail);
                }}
              >
                {rowData.mail}
              </span>
            </div>
          )}
        />
        <Column
          style={{ cursor: "pointer" }}
          field="num"
          header="Tél."
          bodyStyle={{ fontSize: "14px" }}
          body={(rowData) => (
            <div>
              <span
                onClick={() => {
                  copyToClipboard(rowData.num);
                }}
              >
                {rowData.num}
              </span>
            </div>
          )}
        />

        <Column
          header="Besoin"
          bodyStyle={{ width: "16%", fontSize: "14px" }}
          body={(rowData) => (
            <>
              <span>
                {" "}
                {rowData.ville} <small>({mapDim(rowData.dimension)})</small>
              </span>
            </>
          )}
        />

        <Column
          field="note"
          header="Notes"
          bodyStyle={{ fontSize: "14px", maxWidth: "100px" }}
          body={(rowData) => {
            const date = new Date(rowData.dateNote);
            const day = String(date.getDate()).padStart(2, "0");
            const month = String(date.getMonth() + 1).padStart(2, "0");
            const year = date.getFullYear();

            return (
              <div>
                <span>
                  {rowData.note}{" "}
                  <small style={{ fontSize: "10px" }}>
                    ({day}/{month})
                  </small>
                </span>
              </div>
            );
          }}
        />

        <Column
          header="Actions"
          style={{ textAlign: "center", width: "100px" }}
          body={(rowData) => (
            <div>
              <Button
                icon="pi pi-phone"
                severity="success"
                size="small"
                onClick={() => {
                  setInfoClick(
                    rowData.idFiche,
                    rowData.nom,
                    rowData.num,
                    rowData.dimension,
                    rowData.mail
                  );
                }}
              />
            </div>
          )}
        />
      </DataTable>
    </>
  );
}
